var _circle, _path, _circle2, _path2, _path3, _circle3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMembers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 14.5,
    r: 5.5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.75 22.5A7.748 7.748 0 0114 14.75 7.748 7.748 0 0121.75 7a7.748 7.748 0 017.75 7.75 7.748 7.748 0 01-7.75 7.75zm0-2.583a5.165 5.165 0 005.167-5.167 5.165 5.165 0 00-5.167-5.167 5.165 5.165 0 00-5.167 5.167 5.165 5.165 0 005.167 5.167z",
    fill: "#000",
    fillOpacity: 0.95
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 18.5,
    r: 5.5,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.75 26.5A7.748 7.748 0 019 18.75 7.748 7.748 0 0116.75 11a7.748 7.748 0 017.75 7.75 7.748 7.748 0 01-7.75 7.75zm0-2.583a5.165 5.165 0 005.167-5.167 5.165 5.165 0 00-5.167-5.167 5.165 5.165 0 00-5.167 5.167 5.165 5.165 0 005.167 5.167z",
    fill: "#000",
    fillOpacity: 0.95
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.973 35c-.274-5.016-4.638-9-9.987-9-5.348 0-9.712 3.984-9.986 9h2.986c0-3.5 3.317-6 7-6 3.507 0 6.681 2.72 6.978 6h3.009zM21 25.06c.324-.04.654-.06.986-.06 3.507 0 6.681 2.72 6.978 6h3.009c-.274-5.016-4.638-9-9.987-9-.332 0-.662.015-.986.046v3.014z",
    fill: "#000",
    fillOpacity: 0.95
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 5.5,
    transform: "matrix(-1 0 0 1 9.973 7.5)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.723 15.5a7.748 7.748 0 007.75-7.75A7.748 7.748 0 009.723 0a7.748 7.748 0 00-7.75 7.75 7.748 7.748 0 007.75 7.75zm0-2.583A5.165 5.165 0 014.556 7.75a5.165 5.165 0 015.167-5.167 5.165 5.165 0 015.166 5.167 5.165 5.165 0 01-5.166 5.167z",
    fill: "#000",
    fillOpacity: 0.95
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.973 18.06a8.142 8.142 0 00-.987-.06c-3.506 0-6.68 2.72-6.977 6h-3.01c.274-5.016 4.639-9 9.987-9 .333 0 .662.015.987.046v3.014z",
    fill: "#000",
    fillOpacity: 0.95
  })));
}
export default SvgMembers;